import React from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../img/svg/close_blue_new_design.svg";

const HeaderIconClose = () => {
  const navigate = useNavigate();
  return (
    <div className={`header-flex`}>
      <img
        src={CloseIcon}
        alt=""
        // className="header-arrow"
        // style={{marginBottom: '5px'}}
        // className="mb-5"
        onClick={() => {
          if (window.location.pathname === "/orderConfirmation") {
            navigate("/");
          } else {
            navigate(-1);
          }
        }}
      />
    </div>
  );
};

export default HeaderIconClose;
